import { injectable } from 'inversify';
import { queryElements, replaceWithElement } from '@/app/shared/utils/content-utils';
import * as Api from "@/app/interaction/api";
import { GalleryItem, GalleryContent, GalleryState } from './gallery-interfaces';
import { createInteractionComponent } from '@/app/interaction/ui'

@injectable()
export class IncludeGalleryHandler implements Api.IncludeComponentsHandlerInterface {
  
  public async includeComponents($parsedContent: any): Promise<Vue[]> {
    const elements: any = queryElements('.gallery.component', $parsedContent);
    if (elements === null) {
      return [];
    }

    let components: Vue[] = []
    for (const element of elements) {
      const $element: any = $(element);
      const component = this.includeComponent($element);
      components.push(component)
    }

    return components
  }

  private includeComponent($element: any): Vue {
    const id: string = $element.attr('id');
    const title: string|null = $('.gallery__title', $element).text() || null;
    const instruction: string|null = $('.gallery__instruction', $element).html() || null;
    const items: GalleryItem[] = this.getItems($('.gallery__item', $element));

    const interactionComponent = createInteractionComponent<GalleryContent, GalleryState>(id, 'gallery', {
      title,
      instruction
    }, {
      items
    })
    interactionComponent.$mount();

    
    // const component = this.interactiveComponentFactory(
    //   'gallery', 
    //   { 
    //     meta: { id, title },
    //     result: null, state: null,
    //     content: {
    //       id, title, instruction, items
    //     }
    //   }
    // );
    // component.$mount();

    replaceWithElement(`#${id}`, interactionComponent.$el);

    return interactionComponent
  }

  private getItems($items: any): GalleryItem[] {
    let items: GalleryItem[] = [];
    $items.each((i: number, item: any) => {
      const $item = $(item);
      items = [...items, {
        imageSrc: $('.gallery__item-image', $item).attr('src') as string,
        title: $('.gallery__item-title', $item).html(),
        content: $('.gallery__item-content', $item).html()
      }];
    });

    return items;
  }
}
